import React, {Fragment} from "react";
import { withStyles, Button } from "@material-ui/core";
import styles from "../styles";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import LogoutIcon from "@material-ui/icons/PowerSettingsNew";
import AuthService from "../../../../auth/AuthService";
import { withAppConfig } from "../../../../appConfigContext";

const profileStyles = theme => ({
    moduleContainer:{
        borderBottom:`1px solid ${theme.AppBGColor}`,
        padding: "16px 32px",
    },
    userDetails:{
        display:"flex"
    },
    userName:{
        fontSize: 14,
        fontWeight: 600,
        color: theme.HeaderSelectedText
    },
    userIcon:{
        fontSize:128
    },
    userInformation:{
        display: "block",
        borderRight:`1px solid ${theme.AppBGColor}`,
        width: "30%"
    },
    userData:{
        display:"block",
        padding:5,
        boxSizing: "border-box",
        fontSize: theme.textFontSize
    },
    fieldName:{
        justifyContent: "flex-end",
        display: "inline-flex",
        width: "50%",
        paddingRight:5,
        boxSizing: "border-box",
        color: theme.TextColor
    },
    fieldValue:{
        justifyContent: "flex-start",
        display: "inline-flex",
        width: "50%",
        paddingLeft: 5,
        boxSizing: "border-box",
        color: theme.TextColor,
        '&$userName':{
            color: theme.HeaderSelectedText
        }
    },
    logoutAction:{
        padding: 24,
        verticalAlign:"middle"
    },
    buttonRoot:{
        textTransform: "none",
        paddingRight: 16
    },
    logoutIcon:{
        padding:"0px 16px 0px 8px"
    }
});
const Profile = props => {
    const { classes } = props;
    const { userProfile } =  props.userData;
    return (
        <Fragment>
        <header className={classes.moduleHeader} data-automationid="profile-title"> User Profile</header>
        <div className={classes.moduleContainer}>
            <div className={classes.userDetails}>
                    <div className={classes.userInformation}>
                        <div className={classes.userData}>
                            <div className={classes.fieldName}> Name :</div>
                            <div className={`${classes.fieldValue} ${classes.userName}`}> {userProfile.userName} </div>
                        </div>
                        <div className={classes.userData}>
                            <div className={classes.fieldName}> {`Current  ${props.configJSON.terminalAccessLabel.fullName} :`}</div>
                            <div className={classes.fieldValue}> {userProfile.terminal.name} </div>
                        </div>
                        <div className={classes.userData}>
                            <div className={classes.fieldName}> {` ${props.configJSON.terminalAccessLabel.fullName} Code :`} </div>
                            <div className={classes.fieldValue}> {userProfile.terminal.code} </div>
                        </div>
                        <div className={classes.userData}>
                            <div className={classes.fieldName}> Job Title :</div>
                            <div className={classes.fieldValue}> {userProfile.jobTitle} </div>
                        </div>
                    </div>
                    <div className={classes.logoutAction}>
                        <Button variant="outlined" size="small" color="primary" classes={{root: classes.buttonRoot}} onClick={AuthService.logout} data-automationid="logOut">
                            <LogoutIcon classes={{root: classes.logoutIcon}}/>
                            Log Out
                        </Button>
                    </div>
            </div>
            <div className={classes.userAdditonalInfo}>

            </div>
        </div>
        </Fragment>
    )
}

export default compose(withStyles((theme) => ({
    ...styles(theme),
    ...profileStyles(theme),
})), withUserProfile, withAppConfig)(Profile)